import LandingLayout from "@/components/layout/LandingPageLayout";
import SectorEcosystemPage from "@/pages/sector-ecosystem/SectorEcosystemPage";

/** Landing chrome for unauthenticated sector overview visits. */
export function SectorGuestView() {
  return (
    <LandingLayout>
      <SectorEcosystemPage />
    </LandingLayout>
  );
}
